
class Validator{
    validateResult = []; //所有规则校验的结果塞到这个数组中
    
    strategys = { //所有的规则定义在这个对象中,如有新的校验规则,在这里面添加,若规则有变动,在这里修改
        isEmpty: function (value, errMsg) {
            if (!value) {
                return errMsg
            }
        },

        maxLength: function (value, length, errMsg) {
            if (value.trim().length > length) {
                return errMsg
            }
        },

        isNum: (value, errMsg) => {
            if (/^\d+$/g.test(value)) {
                return errMsg
            }
        }
    }

    check(value, rules) {
        for (let i = 0; i < rules.length; i++) {
            let rule = rules[i];
            let strategyArry = rule.strategy.split(':');
            let errMsg = rule.errMsg;
            let strategy = strategyArry.shift();
            strategyArry.unshift(value);
            strategyArry.push(errMsg);
            this.validateResult.push(this.strategys[strategy].apply(value, strategyArry)); //遍历规则后,将结果扔进数组
        }
    }

    checkResult() {
        for (let i = 0; i < this.validateResult.length; i++) {
            let errMsg = this.validateResult[i];
            if (errMsg) {
                return errMsg;
            }
        }
    }
}

export {
    Validator
}